var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2 mt-1 mb-5",on:{"click":_vm.downloadPdf}},[_vm._v(" "+_vm._s(_vm.$t('ticketingSystem.processes.reletting.pdf'))+" "),_c('v-icon',[_vm._v("insert_drive_file")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }